var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGettingStarted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.452,
    height: 64,
    viewBox: "0 0 37.452 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c706529c22840917bf8d79379b25a989",
    d: "M9.822,0A2.787,2.787,0,0,0,7,2.763V61.239A2.787,2.787,0,0,0,9.822,64H41.633a2.783,2.783,0,0,0,2.818-2.76V2.763A2.784,2.784,0,0,0,41.633,0H9.822ZM11.919,2a1,1,0,1,1-1,1,1,1,0,0,1,1-1Zm8.881.028h7.884V4H20.8V2.023ZM10.946,6H40.51V54H10.946V6Zm14.782,6.033a7,7,0,1,0,6.9,7A6.96,6.96,0,0,0,25.728,12.029Zm-8.869,16a2,2,0,0,0-1.971,2v2a2,2,0,0,0,1.971,2H34.6a2,2,0,0,0,1.971-2v-2a2,2,0,0,0-1.971-2Zm0,8a2,2,0,0,0-1.971,2v2a2,2,0,0,0,1.971,2H34.6a2,2,0,0,0,1.971-2v-2a2,2,0,0,0-1.971-2ZM25.767,56a3,3,0,1,1-3,3,3,3,0,0,1,3-3Z",
    transform: "translate(-7 -0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingStarted);
export default __webpack_public_path__ + "static/media/getting-started.75c423c32e6ba2ba78e95c82b2df0c47.svg";
export { ForwardRef as ReactComponent };